import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CompetitionDetailDataService implements Resolve<any> {
  preview: string;
  postType: string;

  constructor(private API: ApiService, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot) {
    this.preview = route.queryParamMap.get('preview');
    this.postType = route.queryParamMap.get('blog') ? 'blogs' : 'competitions';

    return this.API.GET(
      `public/${this.postType}/${environment.mall_id}/${route.paramMap.get(
        'slug'
      )}${this.preview === 'true' ? '?preview=' + this.preview : ''}`
    ).pipe(
      catchError((error) => {
        this.router.navigate(['/competitions']);
        return of(null);
      })
    );
  }
}
